<template>
  <header
    :class="classList">
    <slot>Header</slot>
  </header>
</template>

<script>
export default {
  name: 'AppHeader',
  props: {
    fixed: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classList() {
      return [
        'app-header',
        'navbar',
      ];
    },
  },
  mounted() {
    this.isFixed(this.fixed);
  },
  methods: {
    isFixed(fixed) {
      fixed ? document.body.classList.add('header-fixed') : document.body.classList.remove('header-fixed');
      return fixed;
    },
  },
};
</script>
<style scoped>
.app-header {
  height: 64px;
  border: 0px;
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  box-shadow: 0 16px 36px -30px rgba(15, 23, 42, 0.42);
  border-bottom: 1px solid rgba(15, 23, 42, 0.08);
}
</style>
